import { AppError } from './AppError';

/**
 * Represents an error for when input data fails validation.
 * Corresponds to an HTTP 400 Bad Request status.
 */
export class ValidationError extends AppError {
  constructor(message: string = 'Validation failed', details?: any, options?: ErrorOptions) {
    super(message, 400, details, options);
  }
}
